export default "__VITE_ASSET__6443f385__"